import { createContext } from 'react';

import type { PaletteSelection, ResolvedPalette } from './palettes';
import type { ResolvedTheme } from './themes';
import type { ThemeMode } from './themeStorage';

export interface ThemeContextValue {
  /** What the user chose, which may be 'system'. */
  mode: ThemeMode;
  /** What that currently resolves to, after consulting the OS preference. */
  resolved: ResolvedTheme;
  setMode: (mode: ThemeMode) => void;

  /** The chosen primary colour: a preset id, or a custom hex. */
  palette: PaletteSelection;
  /** That choice worked out into a ramp, a surface stop and its contrast. */
  resolvedPalette: ResolvedPalette;
  setPalette: (palette: PaletteSelection) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null);
